import Vue from "vue";

function initialLoad() {
  return {
    DealerSettings: {},
    TestAdfEmailModalInfo: {
      showModal: false,
      data: null
    },
    CXM_AM_DealerSettingsList: []
  };
}

const state = initialLoad();

const actions = {
  loadDealerSettings: function (context, platform) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/pando/dealersettings/" + platform.AccountPlatformID)
        .then(
          function (data) {
            if (data && data.data) {
              let settings = data.data.Data;
              if (settings && settings.DealerSettingsID > 0) {
                context.commit("updateDealerSettings", data.data.Data);
                resolve(data);
              } else {
                context
                  .dispatch("saveDealerSettings", {
                    AccountID: platform.AccountID,
                    AccountPlatformID: platform.AccountPlatformID
                  })
                  .then(function () {
                    context.dispatch("loadDealerSettings", platform);
                  });
              }
            } else reject(error);
          },
          err => {
            resolve(false);
          }
        )
        .catch(function (error) {
          reject(error);
        });
    });
  },
  saveDealerSettings: function (context, settings) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/dealersettings", settings)
        .then(function (data) {
          if (data && data.data.Data) {
            context.commit("updateDealerSettings", data.data.Data);
            resolve(data.data.Data);
          }
        })
        .catch(function (error) {
          console.log("error ", error);
          reject(error);
        });
    });
  },
  async getContactUserAssignmentConfig(context, platformId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "configuration/get",
      {
        accountPlatformId: platformId
      }
    );
    return response && response.data ? response.data : null;
  },
  async saveContactUserAssignmentConfigSettings(context, settings) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "configuration/save",
      settings
    );
    return response && response.data ? response.data : null;
  },
  async getCrmSettings(context, accountPlatformId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      `api/dealer_settings/v1/settings/crm/${accountPlatformId}`
    );
    return response && response.data ? response.data : null;
  },
  async saveCrmSettings(context, settings) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      `api/dealer_settings/v1/settings/crm`,
      settings
    );
    return response && response.data ? response.data : null;
  },
  async getDealerInfo(context, dealerId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      `api/dealer_settings/dealer_setting_all/${dealerId}`
    );
    return response && response.data ? response.data : null;
  },
  async saveDealerInfo(context, dealerInfo) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "api/dealer_settings/update_dealer_setting_all",
      dealerInfo
    );

    //if (response && response.data && response.data.data)
    //context.commit("updateCXM_AM_DealerSettingsList", response.data.data.dealerSettingResponseDto);
    return response;
  },
  async getOppSearchDealerSettings(context, request) {
    let data = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/api/dealer_settings/get_account_platform_settings",
      request
    );
    if (data && data.data && data.data.successful) {
      return data.data.data;
    } else {
      return null;
    }
  },

  async saveOppSearchDealerSettings(context, request) {
    let data = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/api/dealer_settings/save_account_platform_settings",
      request
    );

    if (data && data.data && data.data.data) {
      return data.data.data;
    } else {
      return null;
    }
  },
  async sendTestAdfEmail(context, request) {
    let response = await Vue.http.post("/pando/pandox/sendadftestemail", request);

    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  },
  async getMfaSettings(context, request) {
    let response = await Vue.http.get(`/account/mfaconfiguration?accountId=${request}`, request);

    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  },
  async setMfaSettings(context, request) {
    let response = await Vue.http.post("/account/mfaconfiguration", request);

    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  },
  updateTestAdfEmailModal(context, data) {
    context.commit("updateTestAdfEmailModal", data)
  },
  async getEnterpriseRelationship(context) {
    return await context.getters.CxmApiClient.ProcessRequest("GET", "/api/dealer_relationship").catch(err => err.response);
  },
  async saveEnterpriseRelationship(context, request) {
    return await context.getters.CxmApiClient.ProcessRequest("POST", "/api/dealer_relationship", request).catch(err => err.response);
  },
  async deleteEnterpriseRelationship(context, dealerRelationshipId) {
    return await context.getters.CxmApiClient.ProcessRequest("DELETE", `/api/dealer_relationship/${dealerRelationshipId}`).catch(err => err.response);
  },
  updateCXM_AM_DealerSettingsList(context, data) {
    context.commit("updateCXM_AM_DealerSettingsList", data);
  },
  async creditConvertEstimator(context, payload) {
    return context.getters.CxmApiClient.ProcessRequest(
      "post",
      `/api/dealer_settings/credit_convert/estimate/${payload.calculationType}`,
      payload
    );
  },
  async getDealerFinanceTypes(context, platformIds) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      '/api/push_to_dms/push_to_f_and_i/is_valid_list', platformIds).catch(err => err.response);
    return response && response.data ? response.data.data : null;
  }
};

const mutations = {
  updateDealerSettings: function (state, data) {
    if (data && data.NotificationRules) {
      data.NotificationRules.forEach(rule => {
        rule.Role = null;
        rule.selected_users = null;
        rule.Group = null;
        rule.EventTypeSelected = null;
      });
    }

    if (data && data.ReassignRules) {
      data.ReassignRules.forEach(rule => {
        rule.Role = null;
        rule.selected_user = null;
        rule.Group = null;
        rule.EventTypeSelected = null;
        rule.SelectedAction = null;
      });
    }

    state.DealerSettings = data;
  },
  updateTestAdfEmailModal(state, data) {
    state.TestAdfEmailModalInfo = data;
  },
  updateCXM_AM_DealerSettingsList(state, data) {
    if (!data)
      return;

    if (!state.CXM_AM_DealerSettingsList)
      state.CXM_AM_DealerSettingsList = [];

    let existingRecords = state.CXM_AM_DealerSettingsList;
    let item = {
      dealerId: data.dealer.dealerID,
      settings: data
    }

    if (existingRecords.some(x => x.dealerId == item.dealerId))
      existingRecords.splice(existingRecords.findIndex(y => y.dealerId == item.dealerId), 1, item);
    else
      existingRecords.push(item);

    state.CXM_AM_DealerSettingsList = existingRecords;
  }
};

const getters = {
  DealerSettings: function () {
    return state.DealerSettings;
  },
  CXM_AM_DealerSettingsList() {
    return state.CXM_AM_DealerSettingsList;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DealerSettings.js